import * as css from './SelectBox.css';

import type { ColorVariants, GraphColorVariants, SizeVariants } from './SelectBox.css';

export type { GraphColorVariants } from './SelectBox.css';

interface SelectBoxProps {
    /**
     * When true, the box renders in its selected (checked) state.
     */
    selected?: boolean;

    /**
     * Visual size variant of the select box.
     *
     * @default 'small'
     */
    size?: SizeVariants;

    /**
     * Color variant used for the background and border styling.
     *
     * @default 'white'
     */
    color?: ColorVariants;

    selectColor?: GraphColorVariants;
}

export function SelectBox({ selected, size = 'small', color = 'white', selectColor }: SelectBoxProps) {
    return (
        <div className={css.selectBox({ size, color })} role="checkbox" aria-checked={selected} tabIndex={0}>
            {selected && <span className={css.fill({ selectColor })} />}
        </div>
    );
}
